/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of AOMGH5CustomPlugin
 */

import { ITrackedEvent } from 'com/didichuxing/tracker/event/ITrackedEvent';
import { ITrackedEventArgs } from 'com/didichuxing/tracker/plugin/IReportingStrategyPlugin';
import AReportingStrategyPlugin from 'com/didichuxing/tracker/plugin/AReportingStrategyPlugin';
import OMGH5CustomEvent from 'com/didichuxing/tracker/h5/plugins/events/OMGH5CustomEvent';
import PluginUtils from 'com/didichuxing/tracker/plugin/utils/PluginUtils';

export default abstract class AOMGH5CustomPlugin extends AReportingStrategyPlugin {

    /**
     * @override
     * @inheritDoc
     * @returns {string}
     */
    public getName(): string {
        return PluginUtils.PLUGIN_NAME_CUSTOM;
    }

    /**
     * @override
     * @inheritDoc
     */
    public execute(): void {
        /* Nothing to execute */
    }

    /**
     * @override
     * @inheritDoc
     */
    public exit(): void {
        /* Nothing to exit */
    }

    /**
     * @override
     * @inheritDoc
     * @param {ITrackedEventArgs} eventArgs
     * @returns {ITrackedEvent}
     */
    protected generateEvent(eventArgs: ITrackedEventArgs): ITrackedEvent {
        return new OMGH5CustomEvent(eventArgs.eventId, eventArgs.attrs, this.getContext(), eventArgs.creatInfo);
    }
}
